import { render, staticRenderFns } from "./soil-header.vue?vue&type=template&id=364d26fe&scoped=true&"
import script from "./soil-header.vue?vue&type=script&lang=js&"
export * from "./soil-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364d26fe",
  null
  
)

export default component.exports